import { CheckSelect } from "vagaro-website-rendering/src/components/CustomMultiSelect";
import { GetComponentOrStyleValueFromDefinition } from "../Data/WBData";
import { AttributeFieldProps } from "./RenderAttributeInput";

export default function SingleCheckField({label,definition,layoutObject,updateFunc,screenSize,siteData,saveFunc}:AttributeFieldProps){

    const val = GetComponentOrStyleValueFromDefinition(definition,layoutObject,screenSize);

    const checked = val!="";

    return( 
        <div
        className="cursor-pointer flex-row gap-med blend-border-top relative"
        style={{background:"#f2f2f2",marginTop:"-12px",padding:"4px 0px 0px 1px"}}
        onClick={(e)=>{
            let newVal = "";
            if(val==""){
              newVal = "true";
            }

            updateFunc(definition.attKey,newVal,definition.targetType);
        }}
        >
      <input type="checkbox"
        
        style={{display:"none"}}
        checked={checked}
    
        onChange={(e)=>{
            let newVal = ""
            if(val==""){
                newVal = "true";
            }
            updateFunc(definition.attKey,newVal,definition.targetType);
        }
        }

      />
      <CheckSelect isChecked={checked} />
      
       <div style={{fontWeight:"400",fontSize:"15px"}}> {definition.label}</div>
    </div>
    );
}